import "bootstrap-icons/font/bootstrap-icons.css";
import { useState } from "react";

import "./user.css";

import { Button, Checkbox, Input, message, Modal, Segmented, Table } from "antd";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Search from "antd/es/transfer/search";
import { changePasswordToAdmin, loadAllStaff, uploadUsersFromExcel } from "../../redux/rtk/features/user/userSlice";
import AttendBtn from "../Buttons/AttendBtn";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import UserDataExport from "./userExportData";

function CustomTable({ list }) {
	const dispatch = useDispatch();
	const [status, setStatus] = useState("true");
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
	const [isFileUploadModalVisible, setIsFileUploadModalVisible] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [userName, setUserName] = useState("");
	const [file, setFile] = useState(null);
	const [errorModalVisible, setErrorModalVisible] = useState(false); // New state for error modal
	const [errorMessage, setErrorMessage] = useState("");
	const { loading } = useSelector((state) => state.users);
	const showModal = () => {
		setIsModalVisible(true);
	};

	// Handle modal OK button


	const handleOk = async () => {
		if (userName.trim() === "") {
			message.warning("Please enter a username.");
			return;
		}
		setIsConfirmModalVisible(true);
	};

	const handleConfirm = async () => {
		await dispatch(changePasswordToAdmin({ userName }));
		setIsModalVisible(false);
		setIsConfirmModalVisible(false);
		setUserName(""); // Clear input field after submission
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setUserName("");
	};

	const handleConfirmCancel = () => {
		setIsConfirmModalVisible(false);
	};
	const handleFileChange = (event) => {
		setFile(event.target.files[0]);
	};



	const downloadFile = (url) => {
		const link = document.createElement("a");
		link.href = url;
		link.target = "_blank";
		link.download = "";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handleDownloadSampleExcel = () => {
		downloadFile("/UserUploadExcel/excelFile.xlsx");

	};
	const showFileUploadModal = () => {
		setIsFileUploadModalVisible(true);
	};

	const handleUpload = () => {
		if (file) {
			console.log("Final isEditMode:", isEditMode);
			const formData = new FormData();
			formData.append('file', file);
			formData.append('isEdit', isEditMode ? "true" : "false");
			// Dispatch the upload action and use a callback to load the staff data once upload is successful
			dispatch(uploadUsersFromExcel(formData))
				.then(() => {
					// Refresh the staff data after successful upload
					dispatch(loadAllStaff({ status: "true" }));
					setIsFileUploadModalVisible(false);
					setFile(null);
					setIsEditMode(false);
				})
				.catch((error) => {
					console.error("Error uploading file:", error);
				});
		}
	};

	const columns = [
		{
			id: 1,
			title: "ID",
			dataIndex: "serial",
			key: "serial"
		},
		{
			id: 2,
			title: "Name",
			key: "fullName",
			render: ({ firstName, lastName }) =>
				(firstName + " " + lastName).toUpperCase(),
		},
		{
			id: 3,
			title: "Usr Name",
			dataIndex: "userName",
			key: "userName",
		},

		{
			id: 5,
			title: "Designation",
			dataIndex: "designationHistory",
			key: "designationHistory",
			render: (record) =>
				record.length > 0 ? record[0].designation.name : "N/A",
		},

		// TODO: fix this column to show the correct data

		{
			id: 6,
			title: "E-Status",
			dataIndex: "employmentStatus",
			key: "employmentStatus",
			render: (record) => (record?.name ? record?.name : "N/A"),
		},
		{
			id: 8,
			title: "Department",
			dataIndex: "department",
			key: "department",
			render: (record) => (record?.name ? record?.name : "N/A"),
		},

		{
			id: 9,
			title: "Shift",
			dataIndex: "shift",
			key: "shift",
			render: (record) => (record?.name ? record?.name : "N/A"),
		},

		{
			id: 7,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => (
				<div className='flex justify-start'>
					<UserPrivateComponent permission={"readSingle-user"}>
						<ViewBtn path={`/admin/hr/staffs/${id}/`} />
					</UserPrivateComponent>
					<UserPrivateComponent permission={"readSingle-attendance"}>
						<AttendBtn path={`/admin/attendance/user/${id}`} />
					</UserPrivateComponent>
				</div>
			),
		},
	];
	//make a onChange function
	const onChange = (value) => {
		setStatus(value);
		dispatch(loadAllStaff({ status: value }));
	};

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

	// Filter the list based on searchTerm
	const filteredList = list?.filter((item) =>
		(item.userName && item.userName.toLowerCase().includes(searchTerm.toLowerCase())) ||
		(item.firstName && item.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
		(item.lastName && item.lastName.toLowerCase().includes(searchTerm.toLowerCase()))
	);



	return (
		<div className="ant-card p-4 rounded mt-5">
			<div className="flex my-2 justify-between">
				<div className="w-50">
					<h4 className="text-2xl mb-2">Employee List</h4>

				</div>
				<div className="flex">

					<Button type="primary" className="mr-2" onClick={showModal}>
						Reset Password
					</Button>
					<Search
						placeholder="Search by username"
						onChange={(e) => setSearchTerm(e.target.value)}
						allowClear
						style={{ marginRight: "10px" }}
					/>

					{list && (
						<div style={{ width: 300, marginLeft: "10px" }}>
							<UserDataExport userData={list} />
						</div>
					)}

					<Modal
						title="Reset User Password"
						visible={isModalVisible}
						onOk={handleOk}
						onCancel={handleCancel}
						okText="Ok"
						cancelText="Cancel"
					>
						<div>
							<label htmlFor="userName">User Name:</label>
							<Input
								id="userName"
								value={userName}
								onChange={(e) => setUserName(e.target.value)}
								placeholder="Enter user name"
							/>

						</div>
					</Modal>

					<Modal
						title="Upload User Data"
						visible={isFileUploadModalVisible}
						onOk={handleUpload}
						onCancel={() => setIsFileUploadModalVisible(false)}
						okText="Upload"
						cancelText="Cancel"
					>
						<div>
							{/* File Upload Input */}
							<div>
								<label htmlFor="fileUpload">Select Excel file:</label>
								<input
									id="fileUpload"
									type="file"
									onChange={handleFileChange}
									accept=".xlsx, .xls"
								/>
							</div>

							<div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
								<Checkbox
									checked={isEditMode}
									onChange={(e) => {
										console.log("Checkbox clicked, new value:", e.target.checked);
										setIsEditMode(e.target.checked);
									}}
								/>
								<p style={{ color: isEditMode ? "green" : "red", marginLeft: "8px" }}>
									<strong>
										{isEditMode
											? "Update existing user data"
											: "Do you want to update existing user data?"}
									</strong>
								</p>
							</div>


							{/* Download Sample Button */}
							<div style={{ marginTop: "10px" }}>
								<Button onClick={handleDownloadSampleExcel} type="dashed">
									Download Sample Excel File
								</Button>
							</div>
						</div>
					</Modal>


					{/* Confirmation Modal */}
					<Modal
						title="Confirm Reset"
						visible={isConfirmModalVisible}
						onOk={handleConfirm}
						onCancel={handleConfirmCancel}
						okText="Confirm"
						cancelText="Cancel"
					>
						<p>Are you sure you want to reset the password for user <strong>{userName}</strong>?</p>
					</Modal>
					<Segmented
						className="text-center rounded text-red-500"
						size="middle"
						options={[
							{
								label: (
									<span>
										<i className="bi bi-person-lines-fill"></i> Active
									</span>
								),
								value: "true",
							},
							{
								label: (
									<span>
										<i className="bi bi-person-dash-fill"></i> Inactive
									</span>
								),
								value: "false",
							},
						]}
						value={status}
						onChange={onChange}
					/>
				</div>
			</div>
			{list && (
				<div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", gap: "20px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
					<Button type="primary" className="mr-2" onClick={showFileUploadModal}>
						Upload Excel
					</Button>

				</div>

			)}
			<Table
				scroll={{ x: true }}
				loading={loading}
				pagination={{
					defaultPageSize: 20,
				}}
				columns={columnsToShow}
				dataSource={filteredList ? addKeys(filteredList) : []}
			/>
		</div>
	);
}

const GetAllCust = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.users.list);

	useEffect(() => {
		dispatch(loadAllStaff({ status: "true" }));
	}, []);

	return (
		<UserPrivateComponent permission={"readAll-user"}>
			<div className="card card-custom">
				<div className="card-body">
					<CustomTable list={list} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default GetAllCust;